import { Accordion, css, mixins, styled } from '@bob/library'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'
import { Link } from 'gatsby'

export const StyledAccordion = styled(Accordion)`
  width: 100%;
  text-align: left;

  & button {
    display: flex;
    align-items: center;
    width: 100%;

    & svg {
      margin-left: auto;
    }
  }

  & + & {
    border-top: 0;
  }
`

export const BaseStyledList = styled.ul`
  list-style: none;
  ${mixins.typography.noColor.subtitleMedium};
  ${mixins.padding(0)};
  ${mixins.padding.left(20)};
  border-top: 1px solid ${mixins.colors.grayMid};
`

export const StyledList = styled(BaseStyledList)`
  ${mixins.padding.left(0)};
  ${mixins.margin(10)};
  border: none;

  ${mixins.media.min.phone} {
    ${mixins.margin(15)};
  }

  ${mixins.media.min.desktop} {
    ${mixins.margin(30)};
  }

  & li {
    &:not(:last-child) {
      border-bottom: 1px solid ${mixins.colors.grayMid};
    }
  }
`

export type MobileMenuProps = {
  isOpen: boolean
}

export const MobileMenuItem = styled.li<MobileMenuProps>`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  ${mixins.padding(10, 0)}
  ${mixins.media.min.tablet} {
    display: none;
  }
`
export const SectionItem = styled.li<MobileMenuProps>`
  ${mixins.media.max.tablet} {
    display: ${(p: MobileMenuProps) => (p.isOpen ? 'block' : 'none')};
  }
`

const ListItemStyling = css`
  display: flex;
  align-items: center;
  text-align: left;
  ${mixins.padding(15, 0)};
  ${mixins.padding.right(15)};

  & svg {
    ${mixins.margin.left(5)}
  }

  &.active {
    color: ${mixins.colors.corporateBlue};
  }
`

export const StyledLink = styled(Link)`
  ${ListItemStyling}
`

export const StyledAnchor = styled.a`
  ${ListItemStyling}
`

export const StyledSpotLinkAnchor = styled(SpotLinkAnchor)`
  ${ListItemStyling}
`

export const AccordionLabel = styled.div`
  ${ListItemStyling}
  ${mixins.typography.noColor.headlineXxs}
`
